import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useCountryData } from 'msp-integrations'
import { ShowOnTablet, HideOnTablet, Icons } from '../../../index'
// import { useCountryData } from 'msp-integrations'
import LanguageModal from '@organisms/LanguageModal/LanguageModal'
import * as T from './Footer.types'

export const NavFooter = ({ children, style }: T.NavFooterProps) => {
  const [showLangModal, setShowLangModal] = useState(false)
  const { formatMessage } = useIntl()
  const i18n = useCountryData()

  const copyRightText =
    '© ' +
    new Date().getFullYear() +
    ' ' +
    formatMessage({
      defaultMessage: 'Melitta Single Portions GmbH & Co. KG',
      id: 'msp.footer.melitta_company_info'
    })

  return (
    <div className='navfooter-wrapper'>
      <HideOnTablet>
        <p>{copyRightText}</p>
      </HideOnTablet>
      {children}
      <div
        className={style.CountryModalWrapper}
        onClick={() => setShowLangModal(true)}
      >
        <Icons iconName='Web' height='12px' width='12px' />
        <div className={style.SelectedCountryWrapper}>
          <p className={style.SelectedCountryPara}>
            {i18n.currentCountry?.country}
          </p>
          <ShowOnTablet>
            {i18n.currentCountry?.country && (
              <p>&nbsp;{`| ${i18n.currentCountry?.lang?.split(' ')[0]}`}</p>
            )}
          </ShowOnTablet>
        </div>
      </div>
      <LanguageModal
        countries={i18n?.countries}
        locale={i18n?.locale}
        show={showLangModal}
        setShow={setShowLangModal}
      />
      <ShowOnTablet>
        <p className={style.MobileCopyRightText}>{copyRightText}</p>
      </ShowOnTablet>
    </div>
  )
}
